module.exports = __webpack_public_path__ + "img/tick_square.4f7ac796.svg";